// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607140534/js/" + chunkId + "." + {"44":"82531b03","225":"84052d7f","481":"0e8499c5","486":"29a5e357","770":"36906a1c"}[chunkId] + ".0.3074443519638007.chunk.js";
};